import './Products.css';

import inventory from "../../lib/inventory.json";

import FullPageMarquee from '../../components/FullPageMarquee';
import Card from '../../components/Card';

import WordDesign from '../../assets/dynamic/word-designs';
import ProductFilter from '../../components/ProductFilter';

function Homepage({ color }) {
  const collections = Object.keys(inventory);

  return (
    <div className={`products page-container section bg bg-image-${color}`}>
      <h2 id="designs" className="sr-only">Designs</h2>
      {/* TODO: add filters */}
      <div className="section-header">
        <FullPageMarquee LoopComponent={() => <WordDesign color={color} />} />
      </div>
      <div className="inventory-list">
        <div className="container">
          {/* <ProductFilter /> */}
          <div className="row">
            {
              collections.map((collection) => {
                return inventory[collection].map((item) => {
                  return (
                    <div className="col-4 center-children" key={`${item.name}-${item.category}`}>
                      <Card item={item} color={color} />
                    </div>
                  )
                });
              })
            }
          </div>
        </div>
      </div>
    </div>
  );
}

export default Homepage;
